import { CommunityFilter } from '../model/CommunityFilter';
import { findNearByProfile } from '../service/PeerProfileService';
import { CommunityDiscoverAction } from './useCommunityDiscover';
import { Dispatch, useCallback } from 'react';

export const useFetchDiscoveringProfiles = () => {
  return useCallback(
    async (
      filter: CommunityFilter,
      dispatch: Dispatch<CommunityDiscoverAction>,
    ) => {
      try {
        const nearByProfiles = await findNearByProfile(filter);
        dispatch({
          type: 'FETCHED_PEER_PROFILE',
          payload: nearByProfiles,
        });
      } catch (e) {
        dispatch({
          type: 'ERROR_FETCHING_PEER_PROFILE',
          payload: 'ERROR FETCHING PEER PROFILE',
        });
      }
    },
    [],
  );
};
